import { Box, Modal } from "@mui/material"
import styles from "./BasicModal.module.scss";
import TitleSubtitle from "../formControls/titleSubtitle/TitleSubtitle";
import SuccessButton from "../formControls/buttons/SuccessButton";
import CancelButton from "../formControls/buttons/CancelButton";

type ButtonProperties = {
    id: string;
    label: string;
    onClick: any;
    isDisabled?: boolean;
}

type Props = {
    openModal: boolean;
    setOpenModal: (value: boolean) => void;
    title: string;
    subTitle?: string;
    successButton?: ButtonProperties;
    cancelButton: ButtonProperties;
    component?: any;
}

export default function BasicModal ({openModal, setOpenModal, title, subTitle, successButton, cancelButton, component}: Props){
    return (<Modal
        open={!!openModal}
        onClose={() => {setOpenModal(false)}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <Box className={styles.modalBackground}>
            <TitleSubtitle title={title} subTitle={subTitle}/>
            {component}
            <Box className={styles.buttonContainer}>
                {successButton && <SuccessButton id={successButton.id} label={successButton.label} onclickHandler={successButton.onClick} disabled={successButton.isDisabled} />}
                {cancelButton && <CancelButton id={cancelButton.id} label={cancelButton.label} onclickHandler={cancelButton.onClick}/>}
            </Box>
        </Box>
    </Modal>)
}